import Vue from 'vue';

Vue.component('latest-donation-context', () => import('./DonationContext'));
Vue.component('latest-donation-widget', () =>
  import(/* webpackChunkName: "latest-donation-widget" */ './Widget/Widget.vue')
);

Vue.component('latest-donation-flow-manager', () =>
  import(/* webpackChunkName: "latest-donation-flow-manager" */ './Widget/DonationFlowManager.vue')
);

Vue.component('latest-new-donate-widget', () =>
  import(/* webpackChunkName: "new-donate-widget" */ './NewDonate')
);
Vue.component('latest-top-donation-page-ribbon', () =>
  import(/* webpackChunkName: "top-donation-page-ribbon" */ './TopDonationPageRibbon')
);


Vue.component('sticky-donate-bar', () =>
  import(/* webpackChunkName: "sticky-donate-bar" */ './Widget/StickyDonateBar.vue')
);


Vue.component('latest-donate-sidebar', () =>
  import(/* webpackChunkName: "donate-sidebar" */ './DonateSidebar')
);
